/**
 * 版本化公告弹窗持久化状态管理
 *
 * 使用 LocalStorage 存储已读版本号，key: `550w_qzm_announce_version`
 * 当存储版本 < 当前版本时展示公告；读写失败静默忽略
 *
 * 参见 requirements 7.1 / 7.2 / 7.3 / 7.8
 */

export const ANNOUNCE_VERSION_KEY = '550w_qzm_announce_version';
export const CURRENT_ANNOUNCE_VERSION = 2;

/**
 * 判断是否应展示公告弹窗
 * - 存储版本 < 当前版本 → 应展示
 * - 存储版本 >= 当前版本 → 不展示
 * - LocalStorage 读取失败 → 不展示（requirements 7.8：静默忽略）
 *
 * @returns {boolean} true 表示应展示公告弹窗
 */
export function shouldShowAnnouncement() {
  try {
    const stored = localStorage.getItem(ANNOUNCE_VERSION_KEY);
    if (stored === null) {
      return true;
    }
    const storedVersion = Number(stored);
    if (isNaN(storedVersion)) {
      return true;
    }
    return storedVersion < CURRENT_ANNOUNCE_VERSION;
  } catch (e) {
    // 读取失败（如 Safari 隐私模式）：静默忽略，不展示
    return false;
  }
}

/**
 * 写入公告已读版本号，写入失败静默忽略（requirements 7.3）
 */
export function markAnnouncementSeen() {
  try {
    localStorage.setItem(ANNOUNCE_VERSION_KEY, String(CURRENT_ANNOUNCE_VERSION));
  } catch (e) {
    // 写入失败（如容量满）静默忽略
  }
}
